import { NoSsr } from '@cian/react-utils';
import { ArticleHeading1, ArticleHeading4, Caption, LinkButton } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './AboutCompany.css';
import { DescriptionRow } from './DescriptionRow';
import { PROFILE_URL } from '../../constants/links';
import { IAgentCard, IAgentCardParticipation } from '../../types/agentCard';
import { Avatar } from '../Avatar';
import { DocumentProof } from '../DocumentProof';
import { Participation } from '../Participation';

interface IAboutBlock {
  label: string;
  text: string;
  action?(): void;
}

interface IDateStat {
  label: string;
  value: string;
}

export interface IAboutCompanyProps {
  descriptionList: IAboutBlock[];
  avatarUrl: IAgentCard['avatarUrl'];
  name: IAgentCard['name'];
  superAgent: React.ReactNode | null;
  dateStats: IDateStat[];
  showProfileLinkButton: boolean;
  isUserIdentifiedByDocuments: boolean;
  participations: IAgentCardParticipation[];
}

export const AboutCompany = ({
  descriptionList,
  avatarUrl,
  name,
  superAgent,
  dateStats,
  showProfileLinkButton,
  isUserIdentifiedByDocuments,
  participations,
}: IAboutCompanyProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['column-avatar']} data-name="CompanyAvatar">
        <NoSsr>
          <Avatar avatarUrl={avatarUrl} />
        </NoSsr>
        {superAgent}
      </div>
      <div className={styles['column-info']}>
        <div className={styles['name']}>
          <ArticleHeading1 data-name="CompanyName">{name}</ArticleHeading1>
          {showProfileLinkButton && (
            <LinkButton target="_blank" size="XS" theme="fill_secondary" href={PROFILE_URL}>
              Редактировать
            </LinkButton>
          )}
        </div>
        {(participations.length > 0 || isUserIdentifiedByDocuments) && (
          <div className={styles['credentials']}>
            {participations.map(item => (
              <Participation key={item.type} participation={item} />
            ))}
            {isUserIdentifiedByDocuments && <DocumentProof text="Документы проверены" />}
          </div>
        )}
        {dateStats.length > 0 && (
          <div className={styles['date-stats']} data-name="CompanyDateStats">
            {dateStats.map(({ label, value }) => (
              <div key={label} className={styles['date-stat']}>
                <Caption color="text-secondary-default">{label}</Caption>
                <ArticleHeading4>{value}</ArticleHeading4>
              </div>
            ))}
          </div>
        )}
        <div className={styles['description']} data-name="CompanyDescription">
          {descriptionList.map(({ label, text, action }, index) => (
            <DescriptionRow key={`${label}-${index}`} label={label} text={text} action={action} />
          ))}
        </div>
      </div>
    </div>
  );
};
